import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import InputText from 'components/Form/InputText';
import {InputProps} from 'components/Form/types';
import isEmail from 'validator/lib/isEmail';

const InputEmail: FC<InputProps> = ({
    disabled,
    name,
    required,
    requiredType,
    rules,
    ...rest
}) => {
    const {t} = useTranslation();

    const registerRules = rules || {
        disabled,
        required,
        validate: (value) => {
            if (required || value)
                return isEmail(value) || t('form:error.emailInvalid');

            return undefined;
        },
    };

    return <InputText name={name} rules={registerRules} {...rest} />;
};

export default InputEmail;
